const hourLabel = hour => `${hour % 12 || 12}${hour % 24 < 12 ? "am" : "pm"}`;

export function hourlyChartData(response, now = new Date()) {
    const labels = Array.isArray(response.hours) ? response.hours : [];
    const anchors = labels.flatMap((label, index) => {
        const match = String(label).match(/^(\d{1,2}):(\d{2})$/);
        return match ? [{ index, minute: Number(match[1]) * 60 + Number(match[2]) }] : [];
    });
    // Support both hourly API responses and older five-minute responses.
    const interval = anchors.length > 1
        ? (anchors[1].minute - anchors[0].minute) / (anchors[1].index - anchors[0].index)
        : labels.length === 1 && anchors.length === 1 ? 60 : 5;
    const anchor = anchors[0] || { index: 0, minute: now.getHours() * 60 };
    const length = Math.max(labels.length, ...(response.sales || []).map(series => series.data?.length || 0),
        ...(response.tonnage || []).map(series => series.data?.length || 0));
    const firstHour = Math.max(0, Math.floor((anchor.minute - anchor.index * interval) / 60));
    const lastHour = Math.min(23, Math.max(now.getHours(), firstHour + Math.floor(Math.max(0, length - 1) * interval / 60)));
    const hours = Array.from({ length: lastHour - firstHour + 1 }, (_, index) => firstHour + index);
    const sum = series => {
        const totals = hours.map(() => 0);
        for (let index = 0; index < length; index++) {
            const bucket = Math.floor((anchor.minute + (index - anchor.index) * interval) / 60) - firstHour;
            if (bucket < 0 || bucket >= totals.length) continue;
            totals[bucket] += (series || []).reduce((total, item) => total + (Number(item.data?.[index]) || 0), 0);
        }
        return totals.map(total => Math.round(total * 100) / 100);
    };
    return {
        hours: hours.map(hour => `${hourLabel(hour)}–${hour === now.getHours() ? "now" : hourLabel(hour + 1)}`),
        sales: [{ name: "Transactions", data: sum(response.sales) }],
        tonnage: [{ name: "Tonnage (t)", data: sum(response.tonnage) }],
    };
}
